import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Switch from "./switch";
import { useDispatch, useSelector } from "react-redux";
import Page404 from "../private/pages/page404";
import { Container, MainContainer, SideBar } from "../private/common/layout/styels";
import { ColumnContainer, RowContainer } from "../styles/containers/styles";
import Header from "../private/common/layout/header";
import Footer from "../private/common/layout/footer";
import Menu from "../private/common/layout/menu";
import Message from "../elements/message";
import Loader from "../elements/loader";
import { useCallback } from "react";
import { useState } from "react";
import { fetchLanguages } from "../../store/actions/languages";
import { useEffect } from "react";
import BackToOverview from "../private/common/layout/backToOverview";
// import { useSelectionContainer } from "@air/react-drag-to-select";
const PageRouter = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const menuStatus = useSelector((state) => state.menuStatus);
  const [meessage, setMessage] = useState({});
  // State to keep track of whether to show the message or not.
  const [showMessage, setShowMessage] = useState(false);
  // State to keep track of whether to show the loader or not.
  const [showLoader, setShowLoader] = useState(false);
  /**
   * Function to set the showLoader state.
   * @param {boolean} status The status of the loader.
   */
  const setLoaderBox = useCallback((status) => {
    setShowLoader(status);
  }, []);
  /**
   * Function to set the message to display.
   * @param {object} messageContent The content of the message.
   */
  const setMessageBox = (messageContent) => {
    setMessage(messageContent);
    setShowMessage(true);
  };
  /**
   * Function to close the message.
   */
  const closeMessage = () => {
    setMessage({ ...meessage, onClose: null });
    setShowMessage(false);
  };
  const fetchLanguage = () => {
    dispatch(fetchLanguages());
  }

  useEffect(() => {
    fetchLanguage();

  }, [])

  

  const themeColors = useSelector((state) => state.themeColors);
  const storedValue = sessionStorage.getItem("small-menu");
  const [isSmallMenu, setIsSmallMenu] = useState((storedValue === undefined || storedValue === "true" || storedValue === null) ? true : false);
  const changeMenu = () => {
    const isMobile = window.innerWidth <= 768;
    if(!isMobile) {
      setIsSmallMenu(!isSmallMenu);
      sessionStorage.setItem("small-menu", !isSmallMenu);
    }
  };

  const createRouter = (router, menu = true) => {
    return <Route key={`${router._id}`} path={`${router.path}`} element={<Switch page={router.element} router={router} />} />;
  };
  return (
  <BrowserRouter>
    <Routes>
      {/* Public routes (without layout) */}
      {/* <Route path="/contact" element={<Switch page="contact" />} />
      <Route path="/impressum" element={<Switch page="imprint" />} /> */}
      <Route path="/sign-up" element={<Switch page="signup" />} />
      <Route path="/forget-password" element={<Switch page="forgetPassword" />} />
      <Route path="/reset-password/:id1/:id2" element={<Switch page="resetPassword" />} />
      <Route path="/invitations/:id1/:id2" element={<Switch page="invitations" />} />
      <Route path="/" element={<Switch page="login" />} />

      <Route path="/channel/:id" element={<Switch page="channel" />} />
      <Route path="/channel/:id/track" element={<Switch page="channel-track" />} />

      {!user?.data?.user && <Route path="/support" element={<Switch page="support" />} />}
      {!user?.data?.user && <Route path="/faq" element={<Switch page="faq" />} />}
      {!user?.data?.user && <Route path="/partner/support" element={<Switch page="support" />} />}
      {!user?.data?.user && <Route path="/partner/faq" element={<Switch page="faq" />} />}


      {/* Private routes (with layout) */}
      {user?.data?.token && (
        <Route
          path="/*"
          element={
            <MainContainer className={`${isSmallMenu ? "small" : ""}`}>
              <Header
                changeMenu={changeMenu}
                setLoaderBox={setLoaderBox}
                setMessage={setMessageBox}
                user={user.data}
              />
              <ColumnContainer className={`${(user.data.user.authorisation==="advisor" && user.data.user.company !== null && sessionStorage.getItem("selected-company")) ? "advisor-main" : "main"}`}>
                <SideBar
                  theme={themeColors}
                  className={`${isSmallMenu ? "small" : ""} ${menuStatus && "active"}`}
                >
                  <Menu
                    changeMenu={changeMenu}
                    setLoaderBox={setLoaderBox}
                    setMessage={setMessageBox}
                    user={user.data}
                  />
                  {/* <Footer /> */}
                </SideBar>
                <RowContainer className="content">
                  <Container className="nopadding fixed down" theme={themeColors}>
                    <Routes>
                      {user?.data?.user && <Route path="/support" element={<Switch page="support" />} />}
                      {user?.data?.user && <Route path="/faq" element={<Switch page="faq" />} />}
                      {user?.data?.user && <Route path="/partner/support" element={<Switch page="support" />} />}
                      {user?.data?.user && <Route path="/partner/faq" element={<Switch page="faq" />} />}

                      {/* Dynamically generated routes */}
                      {user?.data?.menu?.map((menu) => {
                        if (menu.submenus?.length > 0) {
                          return (
                            <React.Fragment key={menu._id}>
                              {createRouter(menu)}
                              {menu.submenus.map((submenu) => createRouter(submenu, false))}
                            </React.Fragment>
                          );
                        }
                        return createRouter(menu);
                      })}

                      <Route path="*" element={<Page404 />} />
                    </Routes>
                  </Container>
                </RowContainer>
              </ColumnContainer>
              {showMessage && (
                <Message
                  meessage={meessage}
                  closeMessage={closeMessage}
                  setLoaderBox={setLoaderBox}
                  showMessage={showMessage}
                />
              )}
              {showLoader && <Loader />}
              {(user.data.user.authorisation==="advisor" && user.data.user.company !== null && sessionStorage.getItem("selected-company")) && <BackToOverview user={user.data.user} />}
            </MainContainer>
          }
        />
      )}

      {/* Fallback 404 for public */}
      <Route path="*" element={<Page404 />} />
    </Routes>
  </BrowserRouter>
);

};

// Export PageRouter component as the default export of the module
export default PageRouter;
